import type { CallerAuthority } from "./authority";

export function canAuthorDashboards(
  authority: Pick<CallerAuthority, "callerMemberships" | "isOrgOwner">,
): boolean {
  return (
    authority.isOrgOwner ||
    authority.callerMemberships.some(
      (membership) =>
        membership.deleted_at == null && membership.member_role !== "viewer",
    )
  );
}
